import { HorizontalButtonGroupButton } from '@frontend/components/common';
import { useEffect, useState } from 'react';

import { ObjectListButtonGroupProps } from './object-list-button-group.component';

interface ViewProps {
    primaryButton: HorizontalButtonGroupButton | null;
    otherButtons: HorizontalButtonGroupButton[];
}

const useObjectListButtonGroup = (props: ObjectListButtonGroupProps): ViewProps => {
    const [primaryButton, setPrimaryButton] = useState<HorizontalButtonGroupButton | null>(null);
    const visibleButtons = props.buttons.filter((b) => (typeof b.hide === 'function' ? !b.hide() : !b.hide));

    useEffect(() => {
        if (visibleButtons.length === 0) {
            setPrimaryButton(null);
            return;
        }
        if (visibleButtons.length === 1) {
            setPrimaryButton(visibleButtons[0]);
            return;
        }
        let btn = visibleButtons.find((b) => b.className?.includes('primary'));
        if (btn) {
            setPrimaryButton(btn);
            return;
        }
        btn = visibleButtons.find((b) => b.id?.toLocaleLowerCase().includes('update'));
        if (btn) {
            setPrimaryButton(btn);
            return;
        }
        setPrimaryButton(visibleButtons[0]);
    }, [visibleButtons]);

    return {
        primaryButton,
        otherButtons: visibleButtons.filter((b) => b !== primaryButton)
    };
};

export default useObjectListButtonGroup;
